import React from 'react';
export default function MorningBrief({ brief, sigs, onNav, onDismiss }) {
  return null; // Surfaced via MorningBriefPage tab instead
}
